import { Box, Stack } from "@mui/material";
import { DisplayOnlyField } from "components/Forms/DisplayOnlyField";

import type { ExceedanceForDrawer } from "./ExceedanceActionDrawer";

import { FacilityStatusIndicator } from "./FacilityStatusIndicator";
import { LabeledValue } from "./LabeledValue";
import { formatComparisonPeriod, formatPeriodSpan } from "./periodFormat";
import { ComparisonMismatchFields } from "./PriorityComparisonSummary";

const fieldRowSx = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
  columnGap: 3,
  rowGap: 2,
};

/** Facility details, then the review's period and status persistence. */
export function ExceedanceHeaderFields({
  exceedance,
  epaIds,
}: {
  exceedance: ExceedanceForDrawer;
  epaIds: readonly string[] | undefined;
}) {
  const comparisons = exceedance.comparisonSummaries?.length
    ? exceedance.comparisonSummaries
    : [exceedance.priorityComparison].filter((comparison) => comparison != null);
  return (
    <Stack spacing={2}>
      <Box sx={fieldRowSx}>
        <LabeledValue label="Organization" value={exceedance.organization} />
        <LabeledValue label="State" value={exceedance.state} />
        {epaIds?.length ? (
          <Stack>
            {epaIds.map((epaId, index) => (
              <DisplayOnlyField
                key={epaId}
                label={index === 0 ? (epaIds.length > 1 ? "EPA IDs" : "EPA ID") : undefined}
                text={epaId}
                copyLabel="EPA ID"
                labelSpacing={0.5}
                small
                showCopyHint
                wrapValue
              />
            ))}
          </Stack>
        ) : null}
        <FacilityStatusIndicator facility={exceedance} details />
      </Box>
      <Box sx={fieldRowSx}>
        <LabeledValue
          label="Period"
          value={formatComparisonPeriod(comparisons) ?? formatPeriodSpan(exceedance)}
        />
        <ComparisonMismatchFields comparisons={comparisons} />
      </Box>
    </Stack>
  );
}
